import { j as e } from "./country-de01c755.js";
import { memo as p, forwardRef as f, useState as d, useImperativeHandle as h } from "react";
import { P as x, s as r } from "./index-e7ddceda.js";
const m = (t) => /* @__PURE__ */ e.jsxs("svg", { width: "48", height: "19", viewBox: "0 0 48 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  /* @__PURE__ */ e.jsx("path", { d: "M14.8529 4.73388C16.266 1.97323 18.9895 0.103516 22.0908 0.103516H38.1275C43.1711 0.103516 47.2598 4.19219 47.2598 9.23583C47.2598 14.2795 43.1711 18.3682 38.1275 18.3682H0.96875C0.96875 18.3682 5.06907 16.5719 6.70445 15.35C10.3373 12.6356 13.0874 8.18298 14.8529 4.73388Z", fill: "#FFE1D0" }),
  /* @__PURE__ */ e.jsxs("g", { filter: "url(#filter0_i_4295_131274)", children: [
    /* @__PURE__ */ e.jsx("path", { d: "M18.918 3.46191H21.2031L22.3298 10.3173L22.5043 11.7613H22.6313L23.3136 10.3173L26.9635 3.46191H29.3279L23.2025 14.824H20.9492L18.918 3.46191Z", fill: "#FF9000" }),
    /* @__PURE__ */ e.jsx("path", { d: "M30.3862 3.46191H32.5285L30.5131 14.824H28.3708L30.3862 3.46191Z", fill: "#FF9000" }),
    /* @__PURE__ */ e.jsx("path", { d: "M32.5332 14.824L34.5485 3.46191H38.357C38.8648 3.46191 39.3303 3.54126 39.7535 3.69995C40.1766 3.85864 40.5416 4.0808 40.8484 4.36644C41.1658 4.65208 41.4091 4.99591 41.5784 5.39792C41.7582 5.79993 41.8482 6.24426 41.8482 6.7309C41.8482 7.35508 41.7371 7.91049 41.5149 8.39714C41.3033 8.88378 41.0018 9.29637 40.6104 9.63491C40.219 9.96286 39.7482 10.2168 39.1981 10.3966C38.6585 10.5659 38.0661 10.6505 37.4208 10.6505H35.4054L34.6755 14.824H32.5332ZM37.7064 8.6193C38.2777 8.6193 38.7537 8.48177 39.1346 8.20671C39.5154 7.92107 39.7059 7.48203 39.7059 6.88959C39.7059 6.477 39.5789 6.14375 39.325 5.88985C39.0817 5.62537 38.722 5.49313 38.2459 5.49313H36.3258L35.7704 8.6193H37.7064Z", fill: "#FF9000" })
  ] }),
  /* @__PURE__ */ e.jsx("defs", { children: /* @__PURE__ */ e.jsxs("filter", { id: "filter0_i_4295_131274", x: "18.918", y: "3.46191", width: "22.9297", height: "12.3623", filterUnits: "userSpaceOnUse", "color-interpolation-filters": "sRGB", children: [
    /* @__PURE__ */ e.jsx("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
    /* @__PURE__ */ e.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
    /* @__PURE__ */ e.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ e.jsx("feOffset", { dy: "1" }),
    /* @__PURE__ */ e.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
    /* @__PURE__ */ e.jsx("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
    /* @__PURE__ */ e.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 0.250837 0 0 0 0 0.182731 0 0 0 0.25 0" }),
    /* @__PURE__ */ e.jsx("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_4295_131274" })
  ] }) })
] }), j = p(m);
function u({ children: t, render: i }, l) {
  const [n, s] = d(!1), a = (o) => {
    s(o);
  };
  return h(l, () => ({
    toggleHavingTrouble(o) {
      s(!!o);
    }
  }), []), /* @__PURE__ */ e.jsx(
    x,
    {
      overlayClassName: r.havingTroubleTip,
      title: null,
      trigger: ["click", "hover"],
      content: /* @__PURE__ */ e.jsx("div", { className: r.havingTroubleContent, children: i && i() }),
      destroyTooltipOnHide: !0,
      zIndex: 1e3,
      open: n,
      onOpenChange: a,
      placement: "bottomLeft",
      children: t
    }
  );
}
const H = f(u);
export {
  H,
  j as M
};
//# sourceMappingURL=HavingTroubleTip-4ba005f0.js.map
